import type { InputHTMLAttributes, ReactNode } from 'react';
import './Checkbox.css';

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'id'> {
  id: string;
  label: ReactNode;
}

/**
 * Eigenes Kaestchen statt Browser-Default, aber mit kleinem Radius (2px)
 * statt Kreis - bleibt Briefpapier, keine App-Checkbox. Das gesamte Label
 * ist klickbar und mindestens 44px hoch (Beruehrungsziel).
 */
export function Checkbox({ id, label, className, ...props }: CheckboxProps) {
  const classes = ['checkbox-field', className].filter(Boolean).join(' ');
  return (
    <label className={classes}>
      <input id={id} type="checkbox" className="checkbox-field__input" {...props} />
      <span className="checkbox-field__label">{label}</span>
    </label>
  );
}
